import Heading from "@/components/atoms/Heading";
import { SectionHeadingType } from "@/components/atoms/SectionHeading";
import CtaButtonGroup, { CtaType } from "@/components/molecules/CtaButtonGroup";
import { FeatureCard, featureCardType } from "./FeatureCard";

export type FeaturesGridPropsType = {
  title: SectionHeadingType;
  cta?: CtaType;
  featureCards: featureCardType[];
};

const FeaturesGrid = ({ title, cta, featureCards }: FeaturesGridPropsType) => {
  return (
    <div className="page-max-width">
      <div className="mb-8 flex justify-between">
        {/* <Typography size="TITLE_1">
          Powerful <span className="text-purple-3">features</span> to fuel your
          success
        </Typography> */}
        <div className="flex w-full items-center justify-between text-start">
          <Heading
            as="h3"
            fontStyle="text-title-20 sm:text-title-32"
            heading={title}
            key={"features-grid-heading"}
            align="text-left"
          />
          {cta && (
            <div>
              <CtaButtonGroup ctas={[cta]} />
            </div>
          )}
        </div>
      </div>
      <div
        className="grid grid-cols-1 gap-6 md:grid-cols-10"
        style={{
          gridAutoRows: "minmax(267px, auto)",
        }}
      >
        {featureCards.map((card) => (
          <FeatureCard card={card} key={card.description} />
        ))}
      </div>
    </div>
  );
};

export default FeaturesGrid;
